















import Vue, { VueConstructor } from "vue";
import topnav from "@/components/Navigation/TopNav.vue";
import sidenav from "@/components/Navigation/SideNav.vue";
import KeyboardGrid from "./components/Keyboard/KeyboardGrid.vue";
//import botnav from "@/components/Navigation/BotNav.vue";
import CookieBanner from "@/components/Navigation/CookieBanner.vue";
const vm = (Vue as VueConstructor<
  Vue & {
    $refs: {
      topnav: {
        closeNav(): void;
      },
      sidenav: {
        openNav(): void;
        closeNav(): void;
        isOpen: boolean;
      };
    };
  }
>).extend({
  data: () => ({
    loggedIn: false,
    hasConsent: true,
    mobile: false
  }),
  components: {
    topnav,
    sidenav,
    //botnav,
    CookieBanner,
    KeyboardGrid
  },
  async created() {
    this.hasConsent = this.$cookies.get("cookiesConsent")
      ? this.$cookies.get("cookiesConsent")
      : false;
    await this.$store.dispatch("appVersion");
  },
  computed: {
    isLoggedIn: function (): boolean {
      return this.loggedIn;
    },
    showCookie: function (): boolean {
      return !this.hasConsent;
    },
    overlayClass: function (): any {
      return {};
    },
  },
  methods: {
    toggleSideNav: function (): void {
      this.$refs.sidenav.openNav();
    },
    closeNav: function () {
      // this.$refs.topnav.closeNav();
    },
    consent: function (): void {
      this.$cookies.set("cookiesConsent", true);
      this.hasConsent = true;
    }
  },
  watch: {
    "$route.fullPath": async function () {
      await this.$store.dispatch("checkStatus");
    }
  }
});

export default vm;
